<p class="text-[#18181A] text-xs !font-normal">{{title}}</p>
<div class="flex justify-between items-center">
    <div [ngClass]="fullWidth ? 'w-full' : 'w-40'" class="bg-gray-300 relative h-1 rounded-sm">
        <div class="top-0 right-0 absolute bg-blue-500 h-full rounded-sm duration-200 transition-all" 
        [ngClass]="{'smoothfillUp': hasAnimation }"
        [style.width]="(+progressValue * 100) / +max
        + '%'"></div>
    </div>
    <div class="text-[#71717A] text-sm mr-2 !font-normal">{{score}}</div>
</div>

